import React, { useEffect, useState } from "react";
import AXIOSCONFIGMETHOD from "../../../../components/apiCall/axiosConfig";
import { webServiceUrl } from "../../../../components/apiCall/webserviceurl";
import Loading from "../../../../components/common/Loading";

function Program_schedule({ program_id }) {
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);
  const local = localStorage.getItem("school_code");
  const getData = async () => {
    try {
      setLoading(true);
      const resp = await AXIOSCONFIGMETHOD(
        "POST",
        webServiceUrl.program_schedule,
        { program_id: local },
      );
      setData(resp?.data || {});
    } catch (error) {
      console.error("Failed to fetch data", error);
    } finally {
      setTimeout(() => setLoading(false), 500);
    }
  };

  useEffect(() => {
    if (local) {
      getData();
    }
  }, [local]);

  return (
    <div>
      {loading ? (
        <div className="py-5" style={{ height: "20vh" }}>
          <Loading />
        </div>
      ) : (
        <section className="max-w-7xl mx-auto px-6 py-12">
          <p className="subHeading my-3">Program Schedule</p>

          {/* ✅ Render only if data exists */}
          {data?.day1 ? (
            <div
              className="prose max-w-full"
              dangerouslySetInnerHTML={{
                __html: data.day1.trim(),
              }}
            />
          ) : (
            <p className="text-gray-500">No schedule available</p>
          )}
        </section>
      )}
    </div>
  );
}

export default Program_schedule;

// import React, { useEffect, useState } from 'react'
// import AXIOSCONFIGMETHOD from '../../../../components/apiCall/axiosConfig'
// import { webServiceUrl } from '../../../../components/apiCall/webserviceurl'
// import { Col, Container } from 'react-bootstrap';
// import { Row } from 'react-bootstrap';
// import Loading from '../../../../components/common/Loading';

// function Program_schedule({ program_id }) {
//   const [data, setData] = useState({})
//   const [loading, setLoading] = useState(true);

//   const getData = async () => {
//     try {
//       setLoading(true);
//       const resp = await AXIOSCONFIGMETHOD("POST", webServiceUrl.program_schedule, {
//         "program_id": program_id
//       });
//       // console.log(resp?.data?.text?.split("/n/p"));
//       setData(resp?.data);
//     } catch (error) {
//       console.error("Failed to fetch data", error);
//     } finally {
//       setTimeout(() => setLoading(false), 1000);
//     }
//   }

//   useEffect(() => {
//     getData()
//   }, []);

//   return (
//     <div>
//       {loading
//         ? <div className="py-5" style={{ height: "20vh" }}><Loading /></div>
//         : <>
//           <section className="max-w-7xl mx-auto px-6 py-12">
//             <p className="subHeading my-3">
//               Program Schedule
//             </p>
//             <Container>
//               <Row className="mb-4">
//                 <Col>
//                   <div
//                     className="prose"
//                     dangerouslySetInnerHTML={{ __html: data?.day1?.trim() || '' }}
//                   />
//                 </Col>

//                 <Col>
//                   <div
//                     className="prose"
//                     dangerouslySetInnerHTML={{ __html: data?.day2?.trim() || '' }}
//                   />
//                 </Col>
//               </Row>
//               <Row className="mb-4">

//                 <Col>
//                   <div
//                     className="prose"
//                     dangerouslySetInnerHTML={{ __html: data?.day3?.trim() || '' }}
//                   />
//                 </Col>
//                 <Col>
//                   <div
//                     className="prose"
//                     dangerouslySetInnerHTML={{ __html: data?.day5?.trim() || '' }}
//                   />
//                 </Col>
//               </Row>

//               {/* <Col>
//       <div
//         className="prose"
//         dangerouslySetInnerHTML={{ __html: data?.day4?.trim() || '' }}
//       />
//     </Col> */}

//             </Container>

//           </section>
//         </>}
//     </div>
//   );

// }

// export default Program_schedule
